import React from "react";

export const skills = [
    {   
        id: 1,
        name: "React",
        per: 75
    },
    {
        id: 2,
        name: "Javascript",
        per: 75
    },
    {
        id: 3,
        name: "HTML",
        per: 85
    },
    {
        id: 4,
        name: "CSS",
        per: 85
    },
    {
        id: 5,
        name: "Java",
        per: 85
    },
    {
        id: 6,
        name: "C & C++",
        per: 75
    },
    {
        id: 7,
        name: "Python",
        per: 75
    },
    {
        id: 8,
        name: "Figma",
        per: 80
    },
    {
        id: 9,
        name: "SQL",
        per: 75
    },
    {
        id: 10,
        name: "Git",
        per: 80
    }
]